import { render, staticRenderFns } from "./ListCandidate.vue?vue&type=template&id=55376edb&"
import script from "./ListCandidate.vue?vue&type=script&lang=js&"
export * from "./ListCandidate.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports